import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-permission-name-input',
  templateUrl: './permission-name-input.component.html',
  styleUrls: ['./permission-name-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PermissionNameInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PermissionNameInputComponent,
    },
  ],
})
export class PermissionNameInputComponent {
  @Input()
  title = "Select Permission Name...";

  @Input()
  isDisabled = false;


  permissionNames = [
    "CARGO_CATEGORY",
    "CATEGORY",
    "CHECK_IN",
    "CLEARING_AGENT",
    "CLEARING_COMPANY",
    "CLIENT",
    "COMMODITY_CATEGORY",
    "COMMODITY_PACKAGING",
    "COMMODITY_WAREHOUSE",
    "CLIENT_WAREHOUSE",
    "COMMODITY",
    "COMPANY_SETTINGS",
    "CONTAINER_SIZE",
    "CONTAINER_TRANSACTION_TYPE",
    "CONTAINER_TRANSACTION_STATUS",
    "CONTAINER_TRANSACTION",
    "CONTAINER_TRANSPORTATION",
    "CURRENCY_RATE",
    "GRADE",
    "IMPORTER",
    "INTERNAL_WAREHOUSE_TRANSACTION",
    "LOAD_PORT",
    "LOAD_TYPE",
    "LOADING_BAY",
    "LOADING_FORMAT",
    "PACKAGING",
    "PAGINATED_RESULTS_MODEL",
    "PAGINATION_OPTIONS",
    "PARKING_BAY_SECTION",
    "PARKING_BAY",
    "PERMISSION_ROLE",
    "PERMISSION_USER",
    "PERMISSION",
    "PHYSICAL_EXAM_CATEGORY",
    "PHYSICAL_EXAMINATION_GROUP",
    "PHYSICAL_EXAMINATION",
    "PURPOSE",
    "RECONSTITUTION",
    "REPORT_OPTIONS",
    "ROLE",
    "SHIPPING_LINE",
    "SPECIAL_CONTAINER_CLIENT",
    "STACK",
    "TAG",
    "TOWN",
    "TRANSPORTER",
    "UNIT_OF_MEASURE",
    "USER_ACTIVITY",
    "USER",
    "WAREHOUSE_TRANSACTION_GROUP",
    "WAREHOUSE_TRANSACTION",
    "WAREHOUSE",
    "GATE_CONTROL_SHEET",
    "DAILY_RECONCILIATION_STATEMENT",
    "CLEARED_GATE_CONTROL_SHEET",
    "CLOSED_GATE_CONTROL_SHEET",
    "DAILY_STOCK_REPORT",
    "CLIENTS_MONTHLY_RENTAL_REPORT",
    "CONTAINERS_REPORT",
    "PHYSICAL_EXAMINATION_REPORT",
    "PHYSICAL_EXAMINATION_BY_CATEGORY",
    "PHYSICAL_EXAMINATION_BY_CONTAINER_SIZE",
    "STOCK_BY_WAREHOUSE",
    "STOCK_FOR_STACK",
    "STOCK_BY_BATCH_NUMBER",
    "STOCK_BY_CATEGORY",
  ];

  public value?: string;
  public localValue?: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.value;
    }
  }

  onValueChange(val: string) {
    this.value = val;
    this.onChange(this.value);
    this.writeValue(this.value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
